import { useState, useEffect } from "react"

import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"

import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import MDInput from "components/MDInput"
import { Link } from "react-router-dom"
import MDAlert from "components/MDAlert"

function Change() {
  const [passwordNew, setPasswordNew] = useState("")
  const [repeatPasswordNew, setRepeatPasswordNew] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    document.title = "Portal de monitoreo - Cambiar mi contrase&ntilde;a"
  }, [])

  const validatePassword = (password) => {
    const lengthRegex = /.{8,}/
    const numberRegex = /[0-9]/
    const uppercaseRegex = /[A-Z]/
    const symbolRegex = /[!@#$%^&*(),.?":{}|<>]/

    if (!lengthRegex.test(password)) {
      return "La contrase&ntilde;a debe tener al menos 8 caracteres."
    }
    if (!numberRegex.test(password)) {
      return "La contrase&ntilde;a debe contener al menos un n&uacuote;mero."
    }
    if (!uppercaseRegex.test(password)) {
      return "La contrase&ntilde;a debe contener al menos una letra may&uacuote;scula."
    }
    if (!symbolRegex.test(password)) {
      return "La contrase&ntilde;a debe contener al menos un s&iacuote;mbolo."
    }
    return ""
  }

  const handlePasswordNewChange = (event) => {
    const password = event.target.value
    setPasswordNew(password)

    // Validate the password as the user types
    const validationError = validatePassword(password)
    setError(validationError)
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    // Validate passwords match
    if (passwordNew !== repeatPasswordNew) {
      setError("Las contrase&ntilde;as no coinciden.")
      return
    }

    if (!error) {
      console.log("Password is valid and passwords match.")
      // Add logic here to handle password update
    }
  }

  const alertContent = (name) => (
    <MDTypography variant="body2" color="white">
      {name}
    </MDTypography>
  )

  const renderWarningSB = (
    <MDAlert color="warning" dismissible>
      {alertContent("warning")}
    </MDAlert>
  )

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {renderWarningSB}
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h3" style={{ fontVariant: "small-caps" }}>
                  Cambiar mi contrase&ntilde;a
                </MDTypography>
              </MDBox>
              <MDBox
                pt={2}
                px={2}
                id="formChangePass"
                component="form"
                role="form"
                onSubmit={handleSubmit}
              >
                <MDBox mb={2}>
                  <MDInput
                    type="text"
                    name="username"
                    disabled="true"
                    autoComplete="username"
                    label="Nombre de usuario"
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="password"
                    name="current-password"
                    autoComplete="current-password"
                    label="Contrase&ntilde;a actual"
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="password"
                    name="new-password"
                    autoComplete="new-password"
                    label="Nueva contrase&ntilde;a"
                    onChange={handlePasswordNewChange}
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="password"
                    name="new-password"
                    autoComplete="new-password"
                    label="Repetir contrase&ntilde;a"
                    onChange={(e) => setRepeatPasswordNew(e.target.value)}
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2} sx={{ textAlign: "center" }}>
                  <MDButton type="submit" variant="gradient" color="info" sx={{ mr: 1, width: 90 }}>
                    Actualizar
                  </MDButton>
                  <Link to="/usuarios">
                    <MDButton
                      type="button"
                      variant="outlined"
                      color="info"
                      sx={{ ml: 1, width: 90 }}
                    >
                      Cancelar
                    </MDButton>
                  </Link>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Change
